import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { API } from '../api/client';
import { useApi } from '../api/useApi';

export default function SchedulePriorityCall() {
  const { fiId } = useParams<{ fiId: string }>();
  const navigate = useNavigate();
  const [approved, setApproved] = useState(false);

  const { data: fi, loading: fiLoading, error: fiError } = useApi<any>(() => API.getFI(fiId!), [fiId]);
  const { data: draft, loading: dLoading, error: dError } = useApi<any>(() => API.inviteDraft(fiId!), [fiId]);

  if (fiLoading || dLoading) return <div className="phil-loading">Loading…</div>;
  if (fiError || dError || !fi || !draft) {
    return <div className="phil-error">Unable to load the scheduling email. {fiError ?? dError}</div>;
  }

  const handleSend = () => {
    API.inviteSend(draft.draftId).catch(() => {});
    setApproved(true);
  };

  return (
    <>
      <div className="breadcrumb">
        <a onClick={() => navigate('/feedback-priorities')}>Feedback &amp; Priorities</a>
        <span className="bc-sep">›</span>
        <a onClick={() => navigate(`/fi/${fi.id}`)}>{fi.name}</a>
        <span className="bc-sep">›</span>
        <span>Schedule Priority Call</span>
      </div>

      <div className="page-header">
        <h1>{fi.name} — Schedule Priority Call</h1>
      </div>

      <div>
        <div className="email-box">
          <div className="email-field">
            <span className="email-label">From:</span>
            <span className="email-val">{draft.from}</span>
          </div>
          <div className="email-field">
            <span className="email-label">To:</span>
            <span className="email-val">{draft.to}</span>
          </div>
          <div className="email-field">
            <span className="email-label">Subject:</span>
            <span className="email-val" style={{ fontWeight: 500 }}>{draft.subject}</span>
          </div>
          <div className="email-body">{draft.body}</div>
          <div className="email-footer">
            <button className="btn btn-outline btn-sm" onClick={() => navigate('/admin/email-templates')}>✎ Edit</button>
            <button
              className={`btn btn-sm ${approved ? 'btn-outline' : 'btn-success'}`}
              onClick={handleSend}
              style={{ marginLeft: 'auto' }}
            >
              {approved ? '✓ Sent' : '✓ Approve & Send'}
            </button>
          </div>
        </div>
        {approved && (
          <div style={{ marginTop: 10, padding: '10px 14px', background: '#dcfce7', borderRadius: 7, fontSize: 13, color: '#166534' }}>
            ✓ Email sent to {draft.to} — calendar invites dispatched via Outlook.
          </div>
        )}

        <div style={{ fontSize: 12, color: '#6b7280', marginTop: 14 }}>
          Once approved → agent auto-schedules across Outlook (Teams/Zoom per FI preference)
        </div>
      </div>

      <div style={{ marginTop: 24, display: 'flex', gap: 10 }}>
        <button className="btn btn-outline btn-sm" onClick={() => navigate(`/fi/${fi.id}`)}>← Back to Profile</button>
        <button className="btn btn-outline btn-sm" onClick={() => navigate(`/cal-notifications/${fi.id}`)}>
          CAL Notification →
        </button>
        <button className="btn btn-outline btn-sm" onClick={() => navigate(`/calls/${fi.id}/review`)}>
          Add Transcript →
        </button>
      </div>
    </>
  );
}
